(function($){

	$(document).ready(function(){

	});

	$(document).on('click','#portfolio-filter .portfolio-filter__trigger',function(e){
		e.preventDefault();
		$(this).siblings('.menu-wrapper').slideToggle();
	});

	$(document).on('click','#portfolio-filter .menu-wrapper li',function(e){
		e.preventDefault();
		$('#portfolio-filter').find('.menu-wrapper').slideUp('fast');
		var $target = $(this).data('target');
		$('#portfolio-filter .menu-wrapper ul li[data-target="all"]').remove();

		if($target == 'all') {
			$('.brands-content__grid .post-box').removeClass('hide');
			$('#portfolio-filter').find('.portfolio-filter__trigger').html('Filter');
		} else {
			$('#portfolio-filter').find('.portfolio-filter__trigger').html($target);
			$('#portfolio-filter .menu-wrapper ul').prepend('<li data-target="all">Show All</li>');
			$('.brands-content__grid .post-box').addClass('hide');
			$('.brands-content__grid .post-box.' + $target).removeClass('hide');
		}
	});
	
})(jQuery);